import React from 'react';
import musicData from "../data/musicData";
import {  List } from 'semantic-ui-react';
import renderMusic from "../helperFunctions/renderMusic"



const MusicSection = () => {
    
    return (
        <div className="ui container">
            <List horizontal>
                {renderMusic(musicData)}
            </List>
        </div>
    )
}

export default MusicSection
